import clsx from 'clsx';
import React, { memo } from 'react';
import PropTypes from 'prop-types';

export const defaultLayout = [
    [1, 2, 3, '\\b'],
    [4, 5, 6, ','],
    [7, 8, 9, 0]
];

export const layoutWithoutDot = [
    [1, 2, 3, '\\b'],
    [4, 5, 6, null],
    [7, 8, 9, 0]
];

export function KeyboardInput({ value, isSelection, isFocus = true, placeholder = '0,00' }) {
    const className = clsx('keyboard-input', {
        'keyboard-input-selected': isSelection,
        'keyboard-input-focus': isFocus
    });
    let held = null;
    if (placeholder.indexOf(value) === 0) {
        held = placeholder.substring(value.length);
    }
    return (
        <div className={className}>
            {value && value.length ? (
                <span className="typed">{value}</span>
            ) : (
                <span className="typed typed-empty">&nbsp;</span>
            )}
            {held ? <span className="held">{held}</span> : null}
        </div>
    );
}

KeyboardInput.propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired
};

export const Keyboard = memo(function Keyboard({ dispatch, layout }) {
    return (
        <table className="keyboard">
            <tbody>
                {(layout || defaultLayout).map((row, y) => (
                    <tr key={y}>
                        {row.map((col, x) => (
                            <Key key={x} char={col} dispatch={dispatch} />
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
});

function Key({ char, dispatch }) {
    const className = clsx({
        'keyboard-key': true,
        'keyboard-key-empty': char === null,
        'keyboard-key-comma': char === ',',
        'keyboard-key-backspace': char === '\\b',
        'keyboard-key-numeric': typeof char === 'number'
    });
    if (char === '\\b') {
        return (
            <td className={className} onClick={() => dispatch({ type: 'backspace' })}>
                <div className="backspace" />
            </td>
        );
    }
    return (
        <td className={className} onClick={char === null ? null : () => dispatch({ type: 'append', payload: char })}>
            {char}
        </td>
    );
}

export function format(value) {
    const stringValue = Number(Number(value || 0).toFixed(2)).toString();
    return stringValue.replace('.', ',');
}

export function backwardFormat(value) {
    if (value) {
        return Number(value.replace(',', '.'));
    }
    return 0;
}

export function parse(amount) {
    if (amount && amount.toString) {
        amount = amount.toString();
    }
    const replaced = (amount || '').replace(',', '.');
    return Number(Number(replaced).toFixed(2));
}
